import React, { Component } from "react";
import { AddProcess } from "./AddProcess";

export class AdminProcess extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loadingPage: false, process: [], processInfoEdit: {}
        }
    }

    componentDidMount() {
        this.getProcess();
    }

    async getProcess() {
        this.setState({ loadingPage: true });
        const request = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            },
        }

        const response = await fetch('Process/Get', request);
        const data = await response.json();
        this.setState({ loadingPage: false });

        if (response.redirected) {
            window.location.href = response.url;
        }

        if (data) {
            this.setState({ process: data });
        }
    }

    returnDescriptionProcess() {

    }

    openEditFormAndLoadInfo(processInfo) {
        alert(processInfo.description);
    }

    static renderResult(context) {
        return <div className="resultProcess mt-3">

            <div className="row head">
                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1 border p-3">Id</div>
                <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 border p-3">Nombre proceso</div>
                <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 border p-3">N&uacute;mero proceso</div>
                <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 border p-3">Ciudad</div>
                <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 border p-3">Proceso</div>
                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1 border p-3">Visible</div>
                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1 border p-3"></div>
                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1 border p-3"></div>
            </div>

            {context.state.process.map((item) => <div className="row">
                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1 border p-3">{item.id}</div>
                <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 border p-3">{item.description}</div>
                <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 border p-3">{item.processNumber}</div>
                <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 border p-3">{item.city}</div>
                <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 border p-3">{item.type}</div>
                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1 border p-3">{item.show ? 'Sí' : 'No'}</div>
                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1 border p-3">
                    <a href={`/administrar-procesos/proceso/${item.id}`}>Editar</a>
                </div>
                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1 border p-3"><a href={'/historial-de-pagos/' + item.id} target="_blank">En línea</a></div>
            </div>)}

        </div>
    }

    async search(event) {
        this.state.processFind = [];
        //if (event.currentTarget.value && event.currentTarget.value.length > 2) {
        this.setState({ loading: true, currentInput: event.currentTarget });
        const request = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            }
        }
        event.currentTarget.focus();
        let response = await fetch(`Process/GetProcessByLike?param=${event.currentTarget.value}`, request);

        if (response.redirected) {
            window.location.href = response.url;
        }

        const data = await response.json();
        this.setState({ loadingPage: false });

        if (data) {
            this.setState({ process: data });
        }

        //}
    }

    render() {

        const resultProcess = this.state.loadingPage ? <h2>Cargando...</h2> : AdminProcess.renderResult(this);

        return (

            <div className="wrap-process">
                <fieldset>
                    <legend>Filtrar</legend>
                    <div className="form-group">
                        <label>Buscar por nombre</label>
                        <input type="text" id="searchProcess" className="form-control" disabled={this.state.loadingPage} onChange={(event) => { this.search(event) }} placeholder="Ingrese el nombre del proceso buscar" />
                    </div>
                </fieldset>

                <a href="/administrar-procesos/proceso/0" className="btn btn-primary mt-5">Nuevo proceso</a>

                {resultProcess}
            </div>
        )
    }
}